import React from 'react';
import TaxonomySelection from '../../helper/taxonomySelection';
import MetadataSelection from '../../helper/metadataSelection';
import Select from 'react-select';
import { findIndex } from 'underscore';
import clone from 'clone';
import BuildActions from '../../builder/action/builderActions';
import panelActions from '../action/panelActions';
import ReactToggle from 'react-toggle';
import { stringify } from '../../helper/helperFunction';

class DateRangePicker extends React.Component {
    constructor(props) {
      super(props);
      this.metakey = '_reactive_builder_' + this.props.shortcodeKey;
      this.handleTaxonomy = this.handleTaxonomy.bind(this);
      this.handleMetakey = this.handleMetakey.bind(this);
      this.handleChangeDataTypes = this.handleChangeDataTypes.bind(this);
      this.handleChangeToogleViewTypes = this.handleChangeToogleViewTypes.bind(this);
      this.saveData = this.saveData.bind(this);
      this.handeDateFormat = this.handeDateFormat.bind(this);
      this.handleChangeCalenderViewType = this.handleChangeCalenderViewType.bind(this);
      this.handleMonthView = this.handleMonthView.bind(this);
      this.handleClassName = this.handleClassName.bind(this);
      this.datatypes = [
        {
          'label': 'Metadata',
          'value': 'metakeys',
        },
      ];
      this.toogleviewtype = [
        {
          'label': 'Toogle Show On',
          'value': 'true',
        },
        {
          'label': 'Toogle Show Off',
          'value': 'false',
        },
      ];
      this.DateFormat = [
        {
          'label': 'DD-MM-YYYY',
          'value': 'DD-MM-YYYY',
        },
        {
          'label': 'DD/MM/YYYY',
          'value': 'DD/MM/YYYY',
        },
        {
          'label': 'MM-DD-YYYY',
          'value': 'MM-DD-YYYY',
        },
        {
          'label': 'MM/DD/YYYY',
          'value': 'MM/DD/YYYY',
        },
        {
          'label': 'YYYY/MM/DD',
          'value': 'YYYY/MM/DD',
        },
        {
          'label': 'YYYY-MM-DD',
          'value': 'YYYY-MM-DD',
        },
        {
          'label': 'DD/MMM/YYYY',
          'value': 'DD/MMM/YYYY',
        },
        {
          'label': 'DD-MMM-YYYY',
          'value': 'DD-MMM-YYYY',
        },
        {
          'label': 'DD.MM.YYYY',
          'value': 'DD.MM.YYYY',
        },
        {
          'label': 'MM.DD.YYYY',
          'value': 'MM.DD.YYYY',
        },
        {
          'label': 'YYYY.MM.DD',
          'value': 'YYYY.MM.DD',
        },
        {
          'label': 'Mo MMM YYYY',
          'value': 'Mo MMM YYYY',
        },
        {
          'label': 'Mo MMM, YYYY',
          'value': 'Mo MMM, YYYY',
        },
      ];
      this.calenderView = [
        {
          'label': 'Date Range',
          'value': 'range',
        },
        {
          'label': 'Single Date',
          'value': 'single',
        },
      ];
      this.monthView = [
        {
          'label': 'Double Month',
          'value': 'double',
        },
        {
          'label': 'Single Month',
          'value': 'single',
        },
      ];
      this.settings = {};
    }
    componentWillMount() {
      this.settings = { ...this.props.settings };
      this.setState({
        'settings': { ...this.props.settings },
      });
    }
    componentWillReceiveProps(nextProps) {
      if (nextProps.childUid !== this.props.childUid) {
        this.setState({
          'settings': { ...nextProps.settings },
        });
        this.settings = {};
      }
    }
    handleTaxonomy(val) {
      const value = val === null ? null : val.value;
      this.settings.selectedTaxonomy = value;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handeDateFormat(e) {
      const value = e === null ? 'DD-MM-YYYY' : e.value;
      this.settings.dateFormat = value;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handleMetakey(val) {
      const value = val === null ? null : val.value;
      this.settings.selectedMetakey = value;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handleChangeDataTypes(val) {
      const value = val === null ? null : val.value;
      this.settings.selectedDataType = value;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handelTitle(e) {
      this.settings.title = e.target.value;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handelMaxValue(e) {
      this.settings.maxvalue = e.target.value;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handelMinValue(e) {
      this.settings.minvalue = e.target.value;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handleChangeToogleViewTypes(val) {
      this.settings.selectedToogleViewType = val.target.checked;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handleChangeCalenderViewType(val) {
      this.settings.selectedCalenderViewType = val.value;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handleMonthView(val) {
      const value = val === null ? null : val.value;
      this.settings.selectedMonthViewType = value;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handelSubTitle(e) {
      this.settings.subtitle = e.target.value;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handleClassName(e) {
      this.settings.dynamicNameClassCheckBox = e.target.value;
      this.setState({
        settings: { ...this.state.settings, ...this.settings },
      });
    }
    saveData(e) {
      e.preventDefault();
      const allLayout = clone(this.props.allLayout);
      const find = findIndex(allLayout, { uid: this.props.uid });
      if (find !== -1) {
        const findSearchIndex = findIndex(allLayout[find].searchAttr, { uid: this.props.childUid });
        if (findSearchIndex !== -1) {
          allLayout[find].searchAttr[findSearchIndex] = Object.assign(allLayout[find].searchAttr[findSearchIndex], this.state.settings);
        }
      }
      const pushLayout = {
        allLayout,
        'shortcodeKey': this.props.shortcodeKey,
      };
      BuildActions.saveAllBlocks(pushLayout);
      panelActions.togglePanel('', this.props.shortcodeKey);
    }
    render() {
      return (<div>
        <button className="layout-save-button" onClick={this.saveData}><i className="fa fa-floppy-o"></i><span>Save</span></button>
        <div className="reactive-tab-setting">
          <ul className="nav nav-tabs" role="tablist">
            <li role="presentation" className="active"><a href="#appearance" aria-controls="general" role="tab" data-toggle="tab">Appearance</a></li>
            <li role="presentation"><a href="#populate" aria-controls="populate" role="tab" data-toggle="tab">Data</a></li>
          </ul>
          <div className="tab-content">
            <div role="tabpanel" className="tab-pane active" id="appearance">
              <input type="text" className="reactive-input" value= {stringify(this.state.settings.title)} onChange= { this.handelTitle.bind(this) } placeholder={API.LANG.PLEASE_ENTER_THE_TITLE}/>
              <input type="text" className="reactive-input" value= {stringify(this.state.settings.subtitle)} onChange= { this.handelSubTitle.bind(this) } placeholder={API.LANG.PLEASE_ENTER_THE_SUBTITLE}/>
              <input type="text" className="reactive-input" value= {this.state.settings.dynamicNameClassCheckBox} onChange= { this.handleClassName.bind(this) } placeholder={API.LANG.PLEASE_ENTER_THE_CUSTOM_CSS_CLASSNAME}/>
              <div className="flex-row">
                <div className="flex-md-6 flex-xs-12">
                   <Select
                    name="form-field-name"
                    placeholder={API.LANG.PLACE_TOOGLE}
                    value={this.state.settings.selectedToogleViewType}
                    options={this.toogleviewtype}
                    onChange={this.handleChangeToogleViewTypes}
                  />
                </div>

                <div className="flex-md-6 flex-xs-12">
                  <Select
                    name="form-field-name"
                    placeholder={API.LANG.PLEASE_ENTER_THE_DATE_FORMAT}
                    value={this.state.settings.dateFormat}
                    options={this.DateFormat}
                    onChange={this.handeDateFormat}
                  />
                </div>
              </div>
              <div className="flex-row">
                <div className="flex-md-6 flex-xs-12">
                  <Select
                    name="form-field-name"
                    placeholder={API.LANG.PLACE_CAL_VIEW}
                    value={this.state.settings.selectedCalenderViewType}
                    options={this.calenderView}
                    onChange={this.handleChangeCalenderViewType}
                  />
                </div>

                <div className="flex-md-6 flex-xs-12">
                  <Select
                    name="form-field-name"
                    placeholder={API.LANG.PLACE_MONTH_VIEW}
                    value={this.state.settings.selectedMonthViewType}
                    options={this.monthView}
                    onChange={this.handleMonthView}
                  />
                </div>
              </div>
            </div>
            <div role="tabpanel" className="tab-pane" id="populate">
          { /**
            Please select data type
          */}
          <div className="flex-row">
          <div className="flex-sm-6 flex-md-6 flex-xs-12">
            <Select
              name="form-field-name"
              placeholder={API.LANG.PLEASE_ENTER_A_DATA_TYPE}
              value={this.state.settings.selectedDataType}
              options={this.datatypes}
              onChange={this.handleChangeDataTypes}
            />
          </div>
          </div>
            { this.state.settings.selectedDataType === 'taxonomies' ? <TaxonomySelection onTaxonomySelection={this.handleTaxonomy} value={this.state.settings.selectedTaxonomy} {...this.props} /> : null }
            { this.state.settings.selectedDataType === 'metakeys' ? <MetadataSelection onMetakeySelection={this.handleMetakey} date={true} value={this.state.settings.selectedMetakey} {...this.props} /> : null }
            </div>
          </div>
        </div>

      </div>);
    }
}


DateRangePicker.propTypes = {
  'shortcodeKey': React.PropTypes.number,
  'uid': React.PropTypes.string,
  'childUid': React.PropTypes.string,
  'allLayout': React.PropTypes.array,
  'settings': React.PropTypes.object,
};

export default DateRangePicker;



// WEBPACK FOOTER //
// ./assets/src/frontend/panel/search/dateRangePickerPanel.js